// removed by extract-text-webpack-plugin
module.exports = {"root":"_3EN6INWesmdfb3iIZM3t1P","container":"z8DM-JW2VJQTQUkCWpy8j","arrow-right":"_1Iq-LXoLVYQ2vRwPaILiZs","arrow-left":"_2R2He2VtcIgHgAd_nw5DH0","header":"_1uq9EypDO8Kh2zVHjtkE8i","sortable-column":"_2ubkYlb4KyyaTiNQzEt4Dj","current-order-column":"_6gVBCy6-69Tc6Sik5RJMR","body":"_35lPr4FtEC976iDQTgZnai","showDetail":"_1AfCu_MfbvzeWdJzX0JaZT","expand-button":"_18pYfXYGgkwtA-i3HoiN-K","row-details":"_2ETAAgH0gjDmZ7Q0xhs0yU","muhimma":"_3WXLHZuTJ8GPzaqgQX6sjZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/table.scss
// module id = 1272
// module chunks = 0